import { formatInTimeZone } from 'date-fns-tz'

// return a formatted date string for the given value or an empty string if invalid
export const formatDate = (value: string): string => {
  const date = Date.parse(value)

  if (!date) {
    return ''
  }

  try {
    return formatInTimeZone(new Date(date), Intl.DateTimeFormat().resolvedOptions().timeZone, 'd-MMM-yyyy H:mm zzz')
  } catch {
    return value
  }
}

export const formatDayByDate = (isoString) => {
  const date = new Date(isoString);
  return date.toLocaleDateString('en-US', { //Or another locale like 'en-AU' for DD/MM/YYYY
    month: '2-digit',
    day: '2-digit',
    year: '2-digit'
  });
}

export const formatTimeByDate = (isoString) => {
  const date = new Date(isoString);
  return date.toLocaleTimeString('en-US', { // Or another locale
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false // Set to true for 12-hour format
  });
}